export enum France {
  id = 'FR',
  name = 'France',
  currency = 'EUR',
}
